module.exports = __webpack_public_path__ + "img/keitaro-landing-step-3_2.ru.dcb098bf.jpg";